import React from 'react';
import { EmotionCache } from '@emotion/cache';
import { useServerInsertedHTML } from 'next/navigation';
import { CacheProvider } from '@emotion/react';
import createManagedCache, { EmotionCacheOptions } from '@local/ui/services/createManagedCache';

export interface EmotionCacheProviderProps {
    options: EmotionCacheOptions;
    CacheProvider?: (props: {
        value: EmotionCache;
        children: React.ReactNode;
    }) => JSX.Element | null;
    children: React.ReactNode;
}

export function EmotionCacheProvider({ options, children }: EmotionCacheProviderProps) {
    const [{ cache, flush }] = React.useState(() => createManagedCache(options));

    useServerInsertedHTML(() => {
        const names = flush();

        if (names.length === 0) {
            return null;
        }

        let styles = '';

        for (const name of names) {
            styles += cache.inserted[name];
        }

        return (
            <style
                key={cache.key}
                data-emotion={`${cache.key} ${names.join(' ')}`}
                dangerouslySetInnerHTML={{
                    __html: styles,
                }}
            />
        );
    });

    return <CacheProvider value={cache}>{children}</CacheProvider>;
}

export default EmotionCacheProvider;
